// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-label {
  white-space: initial !important;
  padding: 1px 2px;
}

.div-width {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/cooling-off/cooling-off.component.scss"],"names":[],"mappings":"AAEA;EACI,+BAAA;EACA,gBAAA;AADJ;;AAIA;EACI,WAAA;AADJ","sourcesContent":["\n\nion-label {\n    white-space: initial !important;\n    padding: 1px 2px;\n}\n\n.div-width {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
